<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.assembly.title }}</h2>
      <div class="rte" v-html="wp.assembly.content" />
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutMembersMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.assembly.image})`
    }
  }
}
</script>
